import { createSlice } from "@reduxjs/toolkit";

const safeParse = (value) => {
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
}

const cachedUser = safeParse(localStorage.getItem('user'));

const initialState = {
    isLogging: Boolean(cachedUser),
    user: cachedUser,
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers:{
        setisLogging: (state,action) => {
            state.isLogging = action.payload.isLogging
            state.user = action.payload.user
        }
    }
})

export const {setisLogging} = authSlice.actions
export default authSlice.reducer
